import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { MultipleWeaponSelectionPreview } from '@/features/ui';
import { AdditionalDocumentsPreview } from '@/features/ui/Steps/AdditionalDocuments/AdditionalDocuments';
import { ConfirmationOfApplication } from '@/features/ui/Steps/ConfirmationOfApplication';
import { useProceedNextFromConfirmation } from '@/features/ui/Steps/ConfirmationOfApplication/utils/useProceedNextFromConfirmation';
import { PersonalAndPassportDataPreview } from '@/features/ui/Steps/PersonalAndPassportData';
import { PlaceOfResidencePreview } from '@/features/ui/Steps/PlaceOfResidence';
import { WeaponPlaceOfResidencePreview } from '@/features/ui/Steps/WeaponPlaceOfResidence';

import { Link, StepControlPanel, Typography, ConditionView, Loader } from '@/shared/ui';

import { ROUTES } from '@/router/config';

import { FormDataType } from '@/api/types';

export interface DataPreviewProps {
  handleGeneratePDF: (formData: FormDataType) => Promise<void>;
}

export const DataPreview: React.FC<StepProps<DataPreviewProps>> = ({ next, prev, handleGeneratePDF }) => {
  const { watch, getValues } = useFormContext<FormDataType>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { proceedNextFromConfirmation } = useProceedNextFromConfirmation(next);
  const confirmEnteredDataCorrect = watch('confirmEnteredDataCorrect');

  const handleNextStep = async (): Promise<void> => {
    setIsLoading(true);
    await handleGeneratePDF(getValues())
      .then(proceedNextFromConfirmation)
      .catch((error) => console.error(error))
      .finally(() => setIsLoading(false));
  };

  return (
    <ConditionView if={!isLoading} else={<Loader />}>
      <FormBlock title="Підтвердження даних" className="form-block__data-preview">
        <MultipleWeaponSelectionPreview />
        <PersonalAndPassportDataPreview />
        <PlaceOfResidencePreview />
        <WeaponPlaceOfResidencePreview />
        <AdditionalDocumentsPreview />
      </FormBlock>

      <ConfirmationOfApplication
        confirmLabelElement={
          <Typography>
            Я підтверджую правильність даних та ознайомлений з{' '}
            <Link isExternal to={ROUTES.PERSONAL_DATA}>
              політикою обробки персональних даних
            </Link>
          </Typography>
        }
      />

      <StepControlPanel prev={prev} next={handleNextStep} disabledNext={!confirmEnteredDataCorrect} />
    </ConditionView>
  );
};
